module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-batch-ai flex flex-column"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('body', {
    staticClass: "body"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "btns-operate"
  }, [_c('div', {
    staticClass: "lef flex"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleSelectAll
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleInvertSelect
    }
  }, [_vm._v("反选")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("返回上一步")])], 1), _vm._v(" "), _c('div', {
    staticClass: "rig flex"
  }, [_c('span', {
    staticClass: "sel-t"
  }, [_vm._v(_vm._s(("已选择" + (_vm.selectRows.length) + "项")))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleClearAll
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('el-button', {
    staticClass: "l-c",
    attrs: {
      "disabled": !_vm.selectRows.length
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保存到待发布")])], 1)]), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55",
      "fixed": "left"
    }
  }), _vm._v(" "), _vm._l((_vm.columns), function(item) {
    return [_c('el-table-column', {
      attrs: {
        "prop": item.props,
        "label": item.label,
        "show-overflow-tooltip": "",
        "width": "120"
      }
    })]
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-del",
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.list)
            }
          }
        }, [_vm._v("\n            删除\n          ")])]
      }
    }])
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    model: {
      value: (_vm.visibleSubmit),
      callback: function($$v) {
        _vm.visibleSubmit = $$v
      },
      expression: "visibleSubmit"
    }
  }, [_c('div', {
    staticClass: "sub-dialog"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("批量生成岗位 "), _c('font', {
    staticClass: "col"
  }, [_vm._v("已保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(((_vm.selectRows.length) + "条选中的生成的岗位信息以保存为待发布岗位，您可以移步至待发岗位列表查看编辑。为了保障您与求职者的招聘体验，请仔细检查调整岗位信息后发布。")))]), _vm._v(" "), _c('div', {
    staticClass: "btn-di"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visibleSubmit = false
      }
    }
  }, [_vm._v("好的")]), _vm._v(" "), _c('el-button', {
    staticClass: "l-c",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("查看待发布岗位列表")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "title"
  }, [_vm._v("AI批量岗位生成")]), _vm._v(" "), _c('div', {
    staticClass: "t-info flex"
  }, [_c('span', [_vm._v("1.上传招聘信息文件")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('span', [_vm._v("2.AI识别并批量生成岗位信息")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('span', [_vm._v("3.确认信息并保存")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v("AI识别生成内容或有偏差，内容基本正确的岗位可先选中保存至待发布岗位管理后进行修改微调，并批量上架")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae2f9016","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/posts/btachAi.vue
// module id = 905
// module chunks = 1